module.exports = __webpack_public_path__ + "media/images/bg-wave-5339855c4c6da2136b56fa1a66790878.svg";